module.exports = __webpack_public_path__ + "static/media/open_in_new_window.71752330.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/Images/icons/open_in_new_window.svg
// module id = 1935
// module chunks = 1